import { Box, Text } from "@mantine/core"
import {
  backAndForeColorToHex,
  isEmptyOrBlackOrWhite,
} from "@/utils/color-to-rgba"
import { getFormattedTimePeriod } from "@/utils/get-formatted-time"
import { ActivityPopover } from "../activity-popover"
import css from "./activity-header-cell.module.css"
import { useBatchedActivityType } from "@/-dataloaders/activity-types"
import { OrchestraActivityDto } from "@/orval/gen"

const textSize = "xs"

export function ActivityHeaderCell({
  activity,
  departmentId,
}: {
  activity: OrchestraActivityDto
  departmentId: number
}) {
  const { isPerformance, color } = activity.activityType
  const { data: activityType } = useBatchedActivityType(
    activity.activityType.activityTypeId
  )
  const co =
    isEmptyOrBlackOrWhite(color.foreColor) &&
    isEmptyOrBlackOrWhite(color.backColor) &&
    activityType
      ? activityType.colors
      : color
  const cc = backAndForeColorToHex(co, { mapBlackAndWhiteToUndefined: true })
  const td = activity.isCanceled ? "line-through" : undefined
  return (
    <ActivityPopover
      activityId={activity.activityId}
      departmentId={departmentId}
    >
      <Box
        className={css["activity-container"]}
        style={{
          background: cc.backColor,
          color: cc.foreColor,
        }}
      >
        {activity.hasNotes ? (
          <span className={css["note-indicator"]}></span>
        ) : null}
        <Text
          size={textSize}
          c={cc.foreColor}
          td={td}
          style={{ textWrap: "nowrap", whiteSpace: "pre" }}
        >
          {/* render empty string if no time specified, to have a robust layout */}
          {getFormattedTimePeriod(
            activity.maxCollectivePresencePeriod ?? activity.timePeriod
          ) || " "}
        </Text>{" "}
        <Text
          size={textSize}
          td={td}
          style={{ textWrap: "nowrap", whiteSpace: "pre" }}
        >
          {(activity.activityType.shortName || " ") +
            (activity.activityNumber ? " " + activity.activityNumber : "")}
        </Text>{" "}
        <Text
          size={textSize}
          td={td}
          fw={isPerformance ? "bold" : undefined}
          tt={isPerformance ? "uppercase" : undefined}
          style={{
            textWrap: "nowrap",
            whiteSpace: "pre",
            overflow: "hidden",
          }}
        >
          {activity.title || " "}
        </Text>{" "}
        <Text
          size={textSize}
          td={td}
          c={cc.foreColor}
          style={{ textWrap: "nowrap", whiteSpace: "pre" }}
        >
          {activity.stage || " "}
        </Text>
      </Box>
    </ActivityPopover>
  )
}
